import { css } from 'aphrodite';
import { FormState } from 'react-hook-form';
import { Input } from '../../../../../../web/components-v2/Input';
import { CountrySelector } from '../../../../../../web/components/ValueSelectors/CountrySelector';
import { IAddress, IDonorInfoCollectionOptions } from '../../../../../models/Api';
import { IFormValues } from '../../utils';
import { ErrorMessage } from '../ErrorMessage';
import { styleSheet } from './style';

type Props = {
	address: IAddress;
	collectDonorAddress: IDonorInfoCollectionOptions;
	onAddressChange: (address: IAddress) => void;
	formState: FormState<IFormValues>;
};

export const AddressInput = ({ address, collectDonorAddress, onAddressChange, formState }: Props) => {
	const isRequired = collectDonorAddress.require;

	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.inputContainer)}>
				<label htmlFor='donation-survey-customer-address1'>
					Address Line 1 {isRequired && <span className={css(styleSheet.required)}>*</span>}
				</label>
				<Input
					id='donation-survey-customer-address1'
					value={address?.address1 || ''}
					onChange={e => onAddressChange({ ...address, address1: e.target.value })}
				/>
				{formState?.errors?.address?.address1 && <ErrorMessage message={formState.errors.address.address1.message} />}
			</div>

			<div className={css(styleSheet.inputContainer)}>
				<label htmlFor='donation-survey-customer-address2'>Address Line 2 (Optional)</label>
				<Input
					id='donation-survey-customer-address2'
					value={address?.address2 || ''}
					onChange={e => onAddressChange({ ...address, address2: e.target.value })}
				/>
				{formState?.errors?.address?.address2 && <ErrorMessage message={formState.errors.address.address2.message} />}
			</div>

			<div className={css(styleSheet.addressFieldRow)}>
				<div className={css(styleSheet.addressField)}>
					<label htmlFor='donation-survey-customer-city'>
						City {isRequired && <span className={css(styleSheet.required)}>*</span>}
					</label>
					<Input
						id='donation-survey-customer-city'
						value={address?.city || ''}
						onChange={e => onAddressChange({ ...address, city: e.target.value })}
					/>
					{formState?.errors?.address?.city && <ErrorMessage message={formState.errors.address.city.message} />}
				</div>
				<div className={css(styleSheet.addressField)}>
					<label htmlFor='donation-survey-customer-state'>
						State/Province {isRequired && <span className={css(styleSheet.required)}>*</span>}
					</label>
					<Input
						id='donation-survey-customer-state'
						value={address?.stateProvince || ''}
						onChange={e => onAddressChange({ ...address, stateProvince: e.target.value })}
					/>
					{formState?.errors?.address?.stateProvince && (
						<ErrorMessage message={formState.errors.address.stateProvince.message} />
					)}
				</div>
				<div className={css(styleSheet.addressField)}>
					<label htmlFor='donation-survey-customer-postal'>
						Postal Code {isRequired && <span className={css(styleSheet.required)}>*</span>}
					</label>
					<Input
						id='donation-survey-customer-postal'
						value={address?.postalCode || ''}
						onChange={e => onAddressChange({ ...address, postalCode: e.target.value })}
					/>
					{formState?.errors?.address?.postalCode && (
						<ErrorMessage message={formState.errors.address.postalCode.message} />
					)}
				</div>
			</div>

			<div className={css(styleSheet.inputContainer, styleSheet.countrySelectorContainer)}>
				<label htmlFor='donation-survey-customer-country'>Country (Optional)</label>
				<CountrySelector
					onSelectionChanged={country => onAddressChange({ ...address, country: country.value })}
					selectedValue={address?.country}
				/>
				{formState?.errors?.address?.country && <ErrorMessage message={formState.errors.address.country.message} />}
			</div>
		</div>
	);
};
